import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import WideContainer, { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

const HEADER_HEIGHT = '112px';

export const START_HEIGHT = '400vh';

export const PresentationDomofon = styled.div`
    height: ${START_HEIGHT};
    display: flex;
    width: 100%;
`;

export const InnerWrap = styled.div`
    position: sticky;
    width: 100%;
    height: calc(100vh - ${HEADER_HEIGHT});
    min-height: min-content;
    top: 112px;
`;

export const GridContainer = styled(WideContainer)`
    flex-wrap: nowrap;
    max-width: 100%;

    @media (max-width: ${wideBreakpoints.tablet}) {
        flex-direction: column;
    }
`;

export const Description = styled.div`
    flex: 1;
    position: relative;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;

    @media (max-width: ${wideBreakpoints.tablet}) {
        flex: 1 1 50%;
    }

`;

export const TextBlock = styled.div<{ isVisible: boolean }>`
    flex-direction: column;
    width: 100%;
    margin-bottom: 40px;
    color: ${p => p.isVisible ? COLORS.GRAY_DARK : COLORS.GRAY_S};
    transition: color 0.8s ease-out;

    &:last-child {
        margin-bottom: 0;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        margin-bottom: 36px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        position: absolute;
        margin-bottom: 26px;
        opacity: ${p => p.isVisible ? '1' : '0'};
    }
`;

export const Title = styled.h2`
    ${FONTS.H2};

    @media (max-width: ${wideBreakpoints.laptop}) {
        ${FONTS.H3};
    }
`;

export const Text = styled.div`
    ${FONTS.XL};

    @media (max-width: ${wideBreakpoints.laptop}) {
        ${FONTS.S};
    }
`;

export const ImageWrap = styled.div`
    flex: 0 0 788px;
    position: relative;
    justify-content: center;
    width: 788px;
    height: 100%;
    overflow: hidden;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        flex: 0 0 633px;
        width: 633px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        flex: 0 0 560px;
        width: 560px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        flex: 1 1 50%;
        width: 100%;
    }
`;

export const Picture = styled.picture<{ isVisible: boolean }>`
    position: absolute;
    max-width: 100%;
    max-height: 100%;
    bottom: 0;
    opacity: ${p => p.isVisible ? '1' : '0'};
    transition: opacity 0.8s ease-out;

    flex: 0 0 788px;
    width: 788px;
    height: 100%;

    @media (max-width: ${wideBreakpoints.sDesktop}) {
        flex: 0 0 633px;
        width: 633px;
    }

    @media (max-width: ${wideBreakpoints.laptop}) {
        flex: 0 0 560px;
        width: 560px;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        flex: 1 1 50%;
        width: 100%;
    }
`;

export const Img = styled.img<{ isVisible: boolean }>`
    position: absolute;
    max-width: 100%;
    max-height: 100%;
    bottom: 0;
    opacity: ${p => p.isVisible ? '1' : '0'};
    transition: opacity 0.8s ease-out;

    @media (max-width: ${wideBreakpoints.mobile}) {
        margin: 0 auto;
        left: 0;
        right: 0;
    }
`;
